<table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange.emit($event)">
	<ng-container matColumnDef="no">
		<th mat-header-cell *matHeaderCellDef>Lp.</th>
		<td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
	</ng-container>

	<ng-container matColumnDef="slotId">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
		<td mat-cell *matCellDef="let element">{{ element.id }}</td>
	</ng-container>

	<ng-container matColumnDef="firstName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Imie</th>
		<td mat-cell *matCellDef="let element">{{ element.userData?.firstName }}</td>
	</ng-container>

	<ng-container matColumnDef="lastName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Nazwisko</th>
		<td mat-cell *matCellDef="let element">{{ element.userData?.lastName }}</td>
	</ng-container>

	<ng-container matColumnDef="reservationId">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Rezerwacja</th>
		<td mat-cell *matCellDef="let element">
			<a [routerLink]="['/reservation', element.reservation]" target="_blank" rel="noopener noreferrer">
				{{ element.reservation }}
			</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="notesText">
		<th mat-header-cell *matHeaderCellDef>Notatka</th>
		<td mat-cell *matCellDef="let element">{{ element.notes }}</td>
	</ng-container>

	<ng-container matColumnDef="slotsInReservation">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Ilość osób</th>
		<td mat-cell *matCellDef="let element">{{ element.slotsInReservation }}</td>
	</ng-container>

	<ng-container matColumnDef="stop">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Miasto</th>
		<td mat-cell *matCellDef="let element">
			{{ element[transportSide() === TransportSide.DEPARTURE ? 'stopDeparture' : 'stopReturn']?.stop }}
		</td>
	</ng-container>

	<ng-container matColumnDef="hasPack">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			PAK
			<i
				matTooltip="Ludzie z pakietem komfort są wyświetleni w tabeli pogrubioną czcionką
				Legenda: singleDeck/doubleDeck"
				class="fa-solid fa-circle-info ms-1"
			></i>
		</th>
		<td mat-cell *matCellDef="let element">
			@let side = transportSide();
			@let seat = element.seatnumber;

			@if (!!seat) {
				@let single =
					(side === TransportSide.DEPARTURE
						? seat?.singleDeckDeparture?.number
						: seat?.singleDeckReturn?.number) ?? '–';
				@let double =
					(side === TransportSide.DEPARTURE
						? seat?.doubleDeckDeparture?.number
						: seat?.doubleDeckReturn?.number) ?? '–';

				{{ single }}/{{ double }}
			} @else {
				Brak
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="vehicleBefore">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Autokar przed</th>
		<td mat-cell *matCellDef="let element">
			{{ element.vehicleBefore?.name }}
		</td>
	</ng-container>

	<ng-container matColumnDef="vehicleAfter">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Autokar po</th>
		<td mat-cell *matCellDef="let element">
			{{ element.vehicleAfter?.name }}
		</td>
	</ng-container>

	<ng-container matColumnDef="seat">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Miejsce</th>
		<td mat-cell *matCellDef="let element">
			{{ element.slotVehicle.seat.number }}
		</td>
	</ng-container>

	<ng-container matColumnDef="remove">
		<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
		<td mat-cell *matCellDef="let element">
			<button
				[disabled]="!element.slotVehicle.seat.number"
				(click)="removeSeatEmit.emit(element)"
				mat-icon-button
			>
				<i class="fa-solid fa-xmark"></i>
			</button>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
	<tr
		[attr.data-id]="row.id"
		[attr.data-row]="row | json"
		[ngClass]="{
			'selected-row text-black': row?.id === selectedDataToUpdate()?.selectedSlot?.id,
			'fw-bold': row.hasPack,
			'highlighted-row': highlightedSlotIds().has(row.id),
			'bg-danger text-light': row.doubledSlots,
		}"
		class="slotsTableRow"
		(click)="chooseSlotChange.emit(row)"
		mat-row
		*matRowDef="let row; columns: displayedColumns()"
	></tr>
</table>
